<template>
    <div class="search-bar">
        <DsInputField
            ref="input"
            v-model="search"
            class="search-field"
            :type="showSpinner ? 'text' : 'search'"
            :label="placeholder"
        >
            <template #leading>
                <DsIcon name="search" />
            </template>
            <template #trailing>
                <DsSpinner v-if="showSpinner" size="14" thickness="1" />
            </template>
        </DsInputField>
    </div>
</template>

<script>
export default {
    props: {
        placeholder: String,
        value: String,
        showSpinner: Boolean,
    },

    data() {
        return {
            search: this.value,
        };
    },

    watch: {
        search(val) {
            this.$emit('input', val);
        },

        value(val) {
            this.search = val;
        },
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .search-bar {
        .spinner {
            margin: px-to-rem(4px);
            -webkit-backface-visibility: hidden;
        }
    }

    .search-field {
        width: px-to-rem(300px);

        @media($small) {
            width: 100%;
        }
    }
</style>
